import useApi from '../../services/api/useApi';
import AuthUtils from '../../utils/auth.utils';
import useAuthCookie from './useAuthCookie';

const useAuthToken = () => {
  const api = useApi();
  const { setTokenCookies, removeTokenCookies } = useAuthCookie();

  const setToken = (session: TokenData) => {
    setTokenCookies(session);
  };

  const clearTokens = () => {
    AuthUtils.clearTokens();
    removeTokenCookies();
  };

  const renewTokens = async () => {
    if (AuthUtils.isTokenFromCookieExpired(AuthUtils.tokenNames.refreshToken)) {
      return null;
    }

    const { accessToken, refreshToken, accessTokenExpirationDate, refreshTokenExpirationDate } =
      await api.refresh();

    setToken({
      accessToken,
      refreshToken,
      accessTokenExpirationDate,
      refreshTokenExpirationDate,
    });

    api.addAuthorizationHeader(accessToken);

    return { accessToken, refreshToken };
  };

  const getOrRefreshAccessToken = async () => {
    const accessToken = AuthUtils.getAccessToken() ?? (await renewTokens())?.accessToken;
    return {
      accessToken: accessToken || null,
      expires: AuthUtils.getSessionExpirationDate() ?? null,
    };
  };

  return { setToken, getOrRefreshAccessToken, clearTokens, renewTokens };
};

export default useAuthToken;
